function DeleteIcon() {
  return (
    <svg
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Iconly/Light/Delete">
        <g id="Delete">
          <path
            id="Stroke 1"
            d="M16.604 7.89014C16.604 7.89014 16.1515 13.5026 15.889 15.8668C15.764 16.996 15.0665 17.6576 13.924 17.6785C11.7499 17.7176 9.5732 17.7201 7.39986 17.6743C6.3007 17.6518 5.61486 16.9818 5.49236 15.8726C5.2282 13.4876 4.7782 7.89014 4.7782 7.89014"
            stroke="#FC4040"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Stroke 3"
            d="M17.7568 5.19963H3.62512"
            stroke="#FC4040"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            id="Stroke 5"
            d="M15.0337 5.19974C14.3796 5.19974 13.8162 4.73724 13.6879 4.0964L13.4854 3.08307C13.3604 2.61557 12.9371 2.29224 12.4546 2.29224H8.92707C8.44457 2.29224 8.02123 2.61557 7.89623 3.08307L7.69373 4.0964C7.5654 4.73724 7.00207 5.19974 6.3479 5.19974"
            stroke="#FC4040"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
    </svg>
  );
}

export default DeleteIcon;
